"use strict";exports.stringIncludes=function(n,t,e){return-1!==n.indexOf(t,e)};
//# sourceMappingURL=stringIncludes.cjs.map
